<template>
  <div>
    <GmapMap
      :center="coordenadasSigueServicio.coordenadasServicio"
      :zoom="15"
      map-type-id="terrain"
      style="width: 100%; height: 400px"
      ref="mapRef"
      :options="{
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
      }"
    >
      <GmapMarker
        :position="coordenadasSigueServicio.coordenadasServicio"
        :draggable="false"
        :icon="{ url: require('../assets/house.svg') }"
      ></GmapMarker>

      <GmapMarker
        :position="coordenadasSigueServicio.coordenadasProveedor"
        :draggable="false"
        :icon="{ url: require('../assets/pipe-moving.svg') }"
      ></GmapMarker>
    </GmapMap>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields(["coordenadasSigueServicio"]),
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped>
</style>